module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 2008 by Ed Macy"), _c('br'), _vm._v("Maps © 2008 by HarperPress"), _c('br'), _vm._v("Drawn by HL Studios")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First published in Great Britain in 2008 by HarperPress, an imprint of HarperCollinsPublishers, London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("eBook ISBN-13: 978-0-8021-9996-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Atlantic Monthly Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 69
// module chunks = 0